import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { axiosErrorHandler } from 'common/helpers/axios.helper';
import { AppDispatch, RootState } from 'app/store';
import { ISearchResult, ISearchPayload } from 'entities/Search/Search.models';
import { searchTransport } from 'entities/Search/Search.transport';

interface IState {
  search: ISearchResult;
  isSearchLoading: boolean;
}

const initialState: IState = {
  search: {
    categories: [],
    goods: [],
  },
  isSearchLoading: false,
};

export const searchSlice = createSlice({
  name: 'search',
  initialState,
  reducers: {
    setSearch(state, action: PayloadAction<ISearchResult>) {
      state.search = action.payload;
    },
    setIsSearchLoading(state, action: PayloadAction<boolean>) {
      state.isSearchLoading = action.payload;
    },
    clearSearch(state) {
      state.search.categories = [];
      state.search.goods = [];
    },
  },
});

export const { setSearch, setIsSearchLoading, clearSearch } = searchSlice.actions;

export const selectSearch = (state: RootState) => state.search.search;
export const selectIsSearchLoading = (state: RootState) => state.search.isSearchLoading;

export const searchReducer = searchSlice.reducer;

export const getSearchSuggestions = (payload: ISearchPayload) => async (dispatch: AppDispatch) => {
  dispatch(setIsSearchLoading(true));

  try {
    const response = await searchTransport.get(payload);
    dispatch(setSearch(response));
  } catch (error) {
    axiosErrorHandler(error);
  } finally {
    dispatch(setIsSearchLoading(false));
  }
};
